import { styleWithoutDisplayNone } from '@/common/util/style'

/**
 * Mixin used by all the components of the hostapp.
 * Since the Vue 3 migration we need to filter attribute to let our components
 * keep control of the attribute/styles they render.
 *
 * Require to add `inheritAttrs: false` to be relevant.
 *
 * @since KJS-6391
 */
export default app => {
  app.mixin({
    computed: {
      rootAttrs() {
        const { style, class: klass, ...attrs } = this.$attrs

        return attrs
      },
      rootStyle() {
        return styleWithoutDisplayNone(this.$attrs.style)
      },
      staticClasses() {
        return this.$attrs.class
      }
    }
  })
}
